<template>
  <div
    style="margin-top: 15%"
    class="animated fadeIn d-flex flex-column align-items-center justify-content-center"
    v-if="isLoading"
  >
    <div v-if="isLoading && isLoading !== true" style="margin-bottom: 16px">
      <h2>{{ isLoading }}</h2>
    </div>
    <div
      style="width: 10rem; height: 10rem"
      class="spinner-border text-primary"
      role="status"
    >
      <span class="sr-only">Loading...</span>
    </div>
  </div>
  <section v-else class="w-100 animated fadeIn" id="tables">
    <mdb-modal
      size="md"
      :show="showModalDelete"
      :centered="true"
      @close="
        () => {
          itemLaunch = null;
          showModalDelete = false;
        }
      "
    >
      <mdb-modal-header>
        <mdb-modal-title>Deletar campanha</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        Tem certeza que deseja deletar a campanha?
      </mdb-modal-body>
      <mdb-modal-footer>
        <mdb-btn
          color="secondary"
          @click.native="
            () => {
              showModalDelete = false;
            }
          "
          >Não</mdb-btn
        >
        <mdb-btn
          color="primary"
          @click.native="
            () => {
              deleteCampaign();
            }
          "
          >Sim</mdb-btn
        >
      </mdb-modal-footer>
    </mdb-modal>
    <mdb-modal
      size="md"
      :show="showModalLaunch"
      :centered="true"
      @close="
        () => {
          itemLaunch = null;
          showModalLaunch = false;
        }
      "
    >
      <mdb-modal-header>
        <mdb-modal-title>Disparar campanha</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        Tem certeza que deseja disparar a campanha?
      </mdb-modal-body>
      <mdb-modal-footer>
        <mdb-btn
          color="secondary"
          @click.native="
            () => {
              showModalLaunch = false;
            }
          "
          >Não</mdb-btn
        >
        <mdb-btn
          color="primary"
          @click.native="
            () => {
              launchCampaign();
            }
          "
          >Sim</mdb-btn
        >
      </mdb-modal-footer>
    </mdb-modal>

    <mdb-row class="mt-4">
      <mdb-col>
        <div class="d-flex justify-content-between flex-wrap">
          <form @submit.prevent class="d-flex align-items-center mr-5">
            <mdb-icon icon="search" class="mr-3" />

            <mdb-input
              style="width: 210px"
              class="m-0"
              type="text"
              v-model="inputSearch"
              placeholder="Digite o texto para filtrar"
            />
          </form>
        </div>
        <div class="w-100 d-flex flex-column align-items-center">
          <mdb-tbl responsive hover bordered class="w-100 text-center">
            <colgroup>
              <col :span="columns.length" />
              <col style="width: 175px" />
            </colgroup>
            <thead class="bg-color-table">
              <tr class="text-white">
                <th v-for="column in columns" :key="column">
                  {{ column }}
                  <mdb-icon
                    v-if="
                      [
                        'Nome da campanha',
                        'Falecido',
                        'Tipo',
                        'Gênero',
                        'Documento',
                        'Idade',
                      ].includes(column)
                    "
                    @click.native="handleSort(column)"
                    style="cursor: pointer; margin-left: 4px"
                    icon="sort"
                  />
                </th>
                <th>Ação</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bordered" v-for="(item, index) in data" :key="index">
                <td>
                  <span class="first-text font-weight-bold">
                    {{ item.name }}
                  </span>
                </td>
                <td>
                  <span class="first-text font-weight-bold">
                    {{ item.totalOfOpportunities }}
                  </span>
                </td>
                <td>
                  <span class="first-text font-weight-bold">
                    {{ item.contactMade }}
                  </span>
                </td>
                <td>
                  <span class="first-text font-weight-bold">
                    {{ item.noContactReturn }}
                  </span>
                </td>
                <td>
                  <span class="first-text font-weight-bold">
                    {{ item.templateCollection }}
                  </span>
                </td>
                <td class="pt-1">
                  <span class="first-text font-weight-bold">
                    <div
                      class="d-flex justify-content-between"
                      style="font-size: 10px"
                    >
                      <div
                        class="d-flex flex-column justify-content-center"
                      ></div>
                      <div>
                        <mdb-btn
                          title="Visualizar"
                          type="button"
                          class="btn btn-blue btn-rounded m-0 ml-3 text-btn nowrap"
                          v-if="item.templateCollection"
                          @click.native="
                            () => {
                              viewCollection(item);
                            }
                          "
                        >
                          <mdb-icon icon="eye" />Ver Coleção
                        </mdb-btn>
                      </div>
                      <div>
                        <mdb-btn
                          title="Deletar"
                          type="button"
                          class="btn btn-blue btn-rounded m-0 ml-3 text-btn nowrap"
                          @click.native="
                            () => {
                              itemLaunch = item;
                              showModalDelete = true;
                            }
                          "
                        >
                          <mdb-icon icon="trash"></mdb-icon>Deletar Campanha
                        </mdb-btn>
                      </div>
                    </div>
                  </span>
                </td>
              </tr>
            </tbody>
          </mdb-tbl>
          <mdb-pagination lg>
            <mdb-page-nav
              prev
              :disabled="currentPageSet === 1"
              @click.native="previousPageSet"
            ></mdb-page-nav>

            <mdb-page-item
              @click.native="alterPage(n + (currentPageSet - 1) * pagesToShow)"
              v-for="n in totalPageSet"
              :key="n"
              :active="page === n + (currentPageSet - 1) * pagesToShow"
              :disabled="page === n + (currentPageSet - 1) * pagesToShow"
              >{{ n + (currentPageSet - 1) * pagesToShow }}</mdb-page-item
            >
            <mdb-page-nav
              next
              :disabled="currentPageSet === pageSet"
              @click.native="nextPageSet"
            ></mdb-page-nav>
          </mdb-pagination>
        </div>
      </mdb-col>
    </mdb-row>
    <!-- EDIT MODAL -->
    <portal to="notification-outlet">
      <mdb-modal size="lg" :show="showModalEdit" @close="showModalEdit = false">
        <mdb-modal-header>
          <mdb-modal-title>Editar Campanha</mdb-modal-title>
        </mdb-modal-header>
        <mdb-modal-body>
          <form @submit.prevent="handleUpdate">
            <div class="grey-text p-3">
              <div class="w-100 input-wrapper">
                <label for="name" class="mt-3 grey-text"
                  >Nome da Campanha</label
                >
                <input
                  v-model="itemEdit.name"
                  type="text"
                  id="name"
                  class="form-control"
                  required
                />
              </div>

              <div class="modal-line">
                <div class="input-wrapper">
                  <label for="Date" class="mt-3">Data de Início</label>
                  <datepicker
                    v-model="itemEdit.start_at"
                    id="Date"
                    bootstrap-styling
                    name="Date"
                    bg
                    :language="ptBR"
                    label="Date"
                    required
                  />
                </div>
                <div class="input-wrapper">
                  <label for="EndDate" class="mt-3">Data Finalização</label>
                  <datepicker
                    v-model="itemEdit.finish_at"
                    id="EndDate"
                    bootstrap-styling
                    name="EndDate"
                    bg
                    :language="ptBR"
                    label="EndDate"
                    required
                  />
                </div>
              </div>
              <div class="mt-3 float-right">
                <mdb-btn color="danger" @click.native="showModalEdit = false"
                  >Cancelar</mdb-btn
                >
                <mdb-btn type="submit" color="primary">Editar</mdb-btn>
              </div>
            </div>
          </form>
        </mdb-modal-body>
      </mdb-modal>
    </portal>
  </section>
</template>

<script>
import {
  mdbRow,
  mdbCol,
  mdbTbl,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbPagination,
  mdbPageItem,
  mdbPageNav,
  mdbBtn,
  mdbInput,
  mdbIcon,
} from "mdbvue";

import { ptBR } from "vuejs-datepicker/dist/locale";
import Datepicker from "vuejs-datepicker";

import {
  getCampaigns,
  updateCampaigns,
  deleteCampaign,
  launchCampaign,
  downloadCampaign,
} from "../../services/Campaign";

import {
  listCredentials,
  listTemplates,
  listTemplateDetails,
} from "../../services/Auth";

export default {
  name: "Campaign",
  components: {
    mdbInput,
    mdbRow,
    mdbCol,
    mdbTbl,
    mdbModal,
    mdbIcon,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn,
    Datepicker,
    mdbPagination,
    mdbPageItem,
    mdbPageNav,
  },
  computed: {
    currentPageSet() {
      return Math.ceil(this.page / this.pagesToShow);
    },
    pageSet() {
      return Math.ceil(this.totalPages / this.pagesToShow);
    },
    totalPageSet() {
      if (this.currentPageSet === this.pageSet) {
        return this.totalPages % this.pagesToShow;
      }
      return this.pagesToShow;
    },
    templates() {
      // remove and clean array to be unique
      return (this.templatesData || []).reduce((acc, el) => {
        if (!acc.includes(el.name)) {
          acc.push(el.name);
        }
        return acc;
      }, []);
    },
    disabledAddGroup() {
      const lastCollection = this.collection[this.collection.length - 1];
      return !lastCollection.selectedName || !lastCollection.selectedNumber;
    },
  },

  data() {
    return {
      campaignView: false,
      sort: true,
      showModalAdd: false,
      showModalEdit: false,
      name: "",
      description: "",
      isDead: "",
      startDate: new Date(),
      endDate: new Date(),
      linkCampaign: "",
      candidates: 1,
      itemEdit: {},
      itemToUpdate: {},
      type: "",
      typeOptions: ["", "Aposentado", "Pensionista"],
      gender: "",
      genderOptions: ["", "Masculino", "Feminino"],
      isDeadOptions: ["", "Sim", "Não"],
      document: "",
      age: "",
      columns: [
        "Nome da campanha",
        "Total de oportunidades",
        "Contatos realizados",
        "Sem retorno de contato",
        "Nome da Coleção",
        // "Não houve contato",
        // "Não tem interesse",
        // "Contato tem interesse",
      ],
      isLoading: false,
      data: [],
      dataBkp: [],
      dataSearch: [],
      dataOrder: [],
      inputSearch: "",
      page: 1,
      limit: 10,
      totalPages: 1,
      pagesToShow: 10,
      order: true,
      showModalLaunch: false,
      showModalDelete: false,
      itemLaunch: null,
      ptBR,
      credentials: [],
      selectedTemplateBody: "",
      selectedTemplateButtons: [],
      selectedTemplateIdentifier: "",
      loadingTemplate: false,
      loadingPreview: false,
      templatesData: [],
      selectedName: "",
      selectedNumber: "",
      collection: [{}],
      numbers: [],
      indexCollection: 0,
      templatesByIdentifier: {},
    };
  },

  created() {
    listCredentials()
      .then((data) => {
        this.credentials = data;
        if (data.length) {
          // remove and clean array to be unique
          this.numbers = (data || []).reduce((acc, el) => {
            if (!acc.includes(el.numero_whatsapp)) {
              acc.push({ label: el.numero_whatsapp, value: el.identificador });
            }
            return acc;
          }, []);
        }
      })
      .catch(() => {
        this.$toast.open({
          position: "top",
          message:
            "Ops, aconteceu um erro ao buscar as credenciais para o usuário atual! Tente novamente com outro usuário!",
          type: "error",
        });
      });
  },
  mounted() {
    this.renderTable();
  },
  watch: {
    inputSearch() {
      const filtered = this.dataBkp.filter(this.filterCampaign);
      this.page = 1;
      this.totalPages = parseInt(Math.ceil(filtered.length / this.limit));
      this.data = this.paginate(filtered, this.limit, this.page);
    },
  },
  methods: {
    addGroup() {
      this.collection = [...this.collection, {}];
      // this.collection.push({});
    },
    // Chama as variáveis do data
    input(key, value, cb) {
      this[key] = value;
      if (cb) this[cb]();
    },
    alterPage(selectedPage) {
      this.page = selectedPage;
      this.renderTable();
    },
    previousPageSet() {
      const iterableCurrentPageSet = this.currentPageSet - 1;
      this.alterPage(this.pagesToShow * (iterableCurrentPageSet - 1) + 1);
    },
    nextPageSet() {
      const iterableCurrentPageSet = this.currentPageSet - 1;
      this.alterPage(this.pagesToShow * (iterableCurrentPageSet + 1) + 1);
    },
    getTemplates(selectedNumber) {
      if (!selectedNumber || !selectedNumber.value) {
        return [];
      }
      // if (!this.templatesByIdentifier[selectedNumber.value])
      this.loadingTemplate = true;
      this.loadingPreview = true;
      document.body.style.cursor = "progress";

      listTemplates(selectedNumber.value)
        .then((data) => {
          if (data.length) {
            this.$set(this.templatesByIdentifier, selectedNumber.value, data);
            // templatesByIdentifier[selectedNumber.value] = data;
            // element.selectedName = data[0].name;
            return (
              this.templatesByIdentifier[selectedNumber.value] || []
            ).reduce((acc, el) => {
              if (!acc.includes(el.name)) {
                acc.push(el.name);
              }
              return acc;
            }, []);
          }
        })
        .catch(() => {
          this.$toast.open({
            position: "top",
            message:
              "Ops, aconteceu um erro ao buscar os templates para o número selecionado! Tente novamente com outro número!",
            type: "error",
          });
        })
        .finally(() => {
          document.body.style.cursor = "auto";
          this.loadingTemplate = false;
        });
    },
    initPreview() {
      const lastCollection = this.collection[this.collection.length - 1];
      this.loadingPreview = true;
      console.log(
        this.templatesByIdentifier[lastCollection.selectedNumber.value].find(
          (el) => el.name == lastCollection.selectedName
        )._id
      );
      listTemplateDetails({
        identifier: lastCollection.selectedNumber.value,
        template_id: this.templatesByIdentifier[
          lastCollection.selectedNumber.value
        ].find((el) => el.name == lastCollection.selectedName)._id,
      })
        .then((data) => {
          if (data.length) {
            this.selectedTemplateBody = data[0].sample_text;
            this.selectedTemplateButtons = data[0].sample_buttons;
          }
        })
        .catch(() => {
          this.$toast.open({
            position: "top",
            message:
              "Ops, aconteceu um erro ao buscar a visualização do template escolhido para o número selecionado! Tente novamente com outro número!",
            type: "error",
          });
        })
        .finally(() => {
          document.body.style.cursor = "auto";
          this.loadingPreview = false;
        });
    },
    filterCampaign(campaign) {
      return campaign.name
        .toLowerCase()
        .includes(this.inputSearch.toLowerCase());
    },
    downloadCampaign(itemC) {
      const item = itemC;
      this.isLoading = "Extraindo Relatório";
      downloadCampaign(item)
        .then((data) => {
          const url = window.URL.createObjectURL(new Blob([data])); // you can mention a type if you wish
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `relatorio-${item.name}-${new Date()}.xlsx`
          ); //this is the name with which the file will be downloaded
          link.click();
          // no need to append link as child to body.
          setTimeout(() => window.URL.revokeObjectURL(url), 0); // this is important too, otherwise we will be unnecessarily spiking memory!

          this.$toast.open({
            position: "top",
            message: "Relatório extraído com sucesso!",
            type: "success",
          });
        })
        .catch(() => {
          this.$toast.open({
            position: "top",
            message:
              "Ops, aconteceu um erro ao extrair o relatório! Tente mais tarde!",
            type: "error",
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    viewCollection(item) {
      this.campaignView = item;
      this.$router.push(`/collections/${item.templateCollection}`);
    },
    launchCampaign() {
      const item = this.itemLaunch;
      this.isLoading = "Disparando campanha";
      launchCampaign(item)
        .then(() => {
          this.renderTable();
          this.$toast.open({
            position: "top",
            message: "Campanha disparada com sucesso!",
            type: "success",
          });
        })
        .catch(() => {
          this.$toast.open({
            position: "top",
            message:
              "Ops, aconteceu um erro ao disparar sua campanha! Tente mais tarde!",
            type: "error",
          });
        })
        .finally(() => {
          this.isLoading = false;
          this.itemLaunch = null;
          this.showModalLaunch = false;
        });
    },
    deleteCampaign() {
      const item = this.itemLaunch;
      this.isLoading = "Deletando a campanha";
      deleteCampaign(item)
        .then(() => {
          this.renderTable();

          this.$toast.open({
            position: "top",
            message: "Campanha deletada com sucesso!",
            type: "success",
          });
        })
        .catch(() => {
          this.$toast.open({
            position: "top",
            message:
              "Ops, aconteceu um erro ao deletar sua campanha! Tente mais tarde!",
            type: "error",
          });
        })
        .finally(() => {
          this.isLoading = false;
          this.itemLaunch = null;
          this.showModalDelete = false;
        });
    },
    renderTable() {
      this.isLoading = true;
      const offset = this.limit * (this.page - 1);
      getCampaigns(this.limit, offset).then((res) => {
        this.isLoading = false;
        const resultData = res.results;
        this.dataBkp = [...resultData];
        this.totalPages = parseInt(Math.ceil(res.total / this.limit));
        this.data = [...resultData];

        // this.data = this.paginate(
        //   [...resultData],
        //   res.limitAsNumber,
        //   this.page
        // );
      });
    },
    handleSort(item) {
      this.sort = !this.sort;
      this.dataSearch = [...this.dataBkp];
      if (item == "Nome da campanha") {
        this.dataSearch.sort((a, b) => this.sortFn(a.name, b.name));
      }
      if (item == "Falecido") {
        this.dataSearch.sort((a, b) => this.sortFn(a.isDead, b.isDead));
      }
      if (item == "Tipo") {
        this.dataSearch.sort((a, b) => this.sortFn(a.type, b.type));
      }
      if (item == "Gênero") {
        this.dataSearch.sort((a, b) => this.sortFn(a.gender, b.gender));
      }
      if (item == "Idade") {
        this.dataSearch.sort((a, b) => this.sortFn(a.age, b.age));
      }
      if (item == "Documento") {
        this.dataSearch.sort((a, b) => this.sortFn(a.document, b.document));
      }
      this.alterPage(1);
    },
    sortFn(a, b) {
      if (this.sort) return a > b ? 1 : b > a ? -1 : 0;
      return a < b ? 1 : b < a ? -1 : 0;
    },

    handleUpdate() {
      const data = {
        id: this.itemEdit.id,
        name: this.itemEdit.name,
        start: this.itemEdit.start_at,
        end: this.itemEdit.finish_at,
      };

      const isEqual =
        JSON.stringify(this.itemEdit) === JSON.stringify(this.itemToUpdate);
      if (!isEqual) {
        updateCampaigns(data)
          .then(() => {
            getCampaigns().then((res) => {
              this.data = res.results;
            });
            this.showModalEdit = false;
            this.$toast.open({
              position: "top",
              message: "Campanha editada com sucesso!",
              type: "success",
            });
            return;
          })
          .catch(() => {
            this.$toast.open({
              position: "top",
              message:
                "Ops, aconteceu um erro ao editar sua campanha! Tente mais tarde!",
              type: "error",
            });
            this.showModalEdit = false;
            return;
          });
      } else {
        this.$toast.open({
          position: "top",
          message: "Campos Inválidos ou totalmente iguais aos já existente!",
          type: "error",
        });
        return;
      }
    },
    clearData() {
      this.name = "";
      this.startDate = new Date();
      this.linkCampaign = "";
      this.candidates = 1;
    },

    paginate(array, page_size, page_number) {
      // human-readable page numbers usually start with 1, so we reduce 1 in the first argument
      return array.slice(
        (page_number - 1) * page_size,
        page_number * page_size
      );
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
button {
  font-size: 0.85em;
  font-weight: bold !important;
}
b {
  font-weight: bold !important;
}

.text-btn {
  display: flex;
  align-content: center;
  flex-direction: row;
  justify-content: center;
  font-weight: bold;
  text-transform: capitalize;
  font-size: 12pt;
}
.nowrap {
  white-space: nowrap;
}
.text-btn i {
  margin-right: 1em;
  display: flex;
  align-self: center;
}
.first-text {
  color: #464e5f;
}
.custom-grey {
  background-color: rgba(0, 0, 0, 0.05);
}
.modal-line {
  display: flex;
  justify-content: space-between;
}

.input-wrapper {
  display: flex;
  flex-direction: column;
  width: 48%;
}
.row-label {
  display: flex !important;
  flex-direction: row;
  gap: 28%;
}
.v-select {
  margin-bottom: 0.5em;
}
.page-item.active.disabled.ripple-parent a {
  color: white !important;
}
</style>

<style>
.custom-grey {
  background-color: rgba(0, 0, 0, 0.05);
}
</style>
